import { onBeforeUnmount, onMounted, ref } from 'vue'
import { liveTriviaModule } from '@/store/liveTrivia/module'

/** A ref of the current time on the server's clock, ticking every `tickMs` while the component is mounted. */
export const useServerNow = (tickMs = 1000) => {
    const serverNowMs = ref(liveTriviaModule.getters.getServerNowMs())
    let tickTimer: ReturnType<typeof setInterval> | null = null

    onMounted(() => {
        tickTimer = setInterval(() => {
            serverNowMs.value = liveTriviaModule.getters.getServerNowMs()
        }, tickMs)
    })

    onBeforeUnmount(() => {
        if (tickTimer) {
            clearInterval(tickTimer)
        }
    })

    return serverNowMs
}
